var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-person-icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_421",
    "data-name": "Ellipse 421",
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#d8d8d8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10865",
    "data-name": "Group 10865",
    transform: "translate(-693 -343)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_420",
    "data-name": "Ellipse 420",
    cx: 19,
    cy: 19,
    r: 19,
    transform: "translate(693 343)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4371",
    "data-name": "Mask Group 4371",
    transform: "translate(693 343)",
    clipPath: "url(#clip-path-person-icon)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-person",
    "data-name": "Icon material-person",
    d: "M19.469,19.469a6.735,6.735,0,1,0-6.735-6.735A6.733,6.733,0,0,0,19.469,19.469Zm0,3.367C14.974,22.836,6,25.093,6,29.571v6.652H32.938V29.571C32.938,25.093,23.964,22.836,19.469,22.836Z",
    transform: "translate(-0.744 1.556)",
    fill: "#ebebeb"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/PersonIcon.5e9ce3b839092cd6c49a117e461f8170.svg";
export { ForwardRef as ReactComponent };